import { Component, ViewChild } from '@angular/core';
import { I18NextModule } from 'angular-i18next';
import { AlertModule, ButtonModule, MbsPopupType, ModalComponent, ModalModule } from 'mbs-ui-kit';

@Component({
  selector: 'mbs-security-alert-modal',
  templateUrl: './security-alert-modal.component.html',
  standalone: true,
  imports: [I18NextModule, ButtonModule, AlertModule, ModalModule]
})
export class SecurityAlertModalComponent {
  @ViewChild(ModalComponent, { static: true }) baseModal: ModalComponent;
  protected readonly MbsPopupType = MbsPopupType;
}
